import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FoodsService {

   // region Atributos
   private API_URL = environment.url;
   // endregion

   // region Constructor
   constructor(private httpClient: HttpClient) {}
   // endregion

   //#region Métodos

   // Obtiene el listado de grupos
   getUserFoods(iduser): Observable<any> {
     return this.httpClient.get(`${this.API_URL}/foods_by_user/${iduser}?all`).pipe(
       map((res) => {
         return res;
       })
     );
   }

   storeQualify(data): Observable<any> {
    return this.httpClient.post(`${this.API_URL}/food_image/qualify`, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

   updateQualify(id, data): Observable<any> {
    return this.httpClient.put(`${this.API_URL}/food_image/qualify/${id}`, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  deleteFoodPost(id): Observable<any> {
    return this.httpClient.delete(`${this.API_URL}/food_image/delete/${id}`).pipe(
      map((res) => {
        return res;
      })
    );
  }

  //  sendNotifications(data): Observable<any> {
  //    return this.httpClient.post<any>(`${this.API_URL}/notification/store`, data).pipe(
  //      map((res) => {
  //        return res;
  //      })
  //    );
  //  }
}
